import React, { useState } from "react";

// Firebase
import {
  getAuth,
  sendPasswordResetEmail,
} from "firebase/auth";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setErrorMessage("");

    if (!email) {
      setErrorMessage("Veuillez entrer une adresse email.");
      return;
    }

    const auth = getAuth();

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Un email de réinitialisation a été envoyé si cette adresse existe. Vérifiez aussi vos spams.");
      } catch (error) {

      if (error.code === "auth/invalid-email") {
        setErrorMessage("Adresse email invalide.");
      } else if (error.code === "auth/user-not-found") {
        setErrorMessage("Aucun compte ne correspond à cette adresse email.");
      } else {
        setErrorMessage("Une erreur est survenue. Veuillez réessayer.");
      }
    }
  };

  return (
    <>
      <div className="login-container">
        <div className="box-forgot-password box">
          <h1>Réinitialiser votre mot de passe</h1>

          <form onSubmit={handleSubmit}>
            <div className="inputs">
              <div className="row" key="forgotPassword">
                <label>Email</label>
                <input
                  type="email"
                  name="forgotPassword"
                  id="forgotPassword"
                  autoComplete="off"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            {message && <span className="error-message" style={{color: 'green'}}>{message}</span>}
            {errorMessage && <span className="error-message">{errorMessage}</span>}

            <button type="submit" className="submit-btn">
              Valider
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
